class CollectionMediaToggle extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)

    this.listeners.add(this.els.button.element, 'click', this.handleClick)
  }

  handleClick () {
    this.isToggled = !this.isToggled
  }

  get isToggled () {
    return this.dataset.mediaToggled === 'true'
  }

  set isToggled (value) {
    this.dataset.mediaToggled = value
    this.els.button.element.setAttribute('aria-pressed', value)

    window.BAO.dispatchEvent(
      window.BAO.EVENTS.COLLECTION_MEDIA_TOGGLE.CHANGED,
      {
        isToggled: value,
      },
    )
  }
}

if (!customElements.get('collection-media-toggle')) {
  customElements.define('collection-media-toggle', CollectionMediaToggle)
}
